<template>
  <el-form @submit.native.prevent="onSubmit" :disabled="!!request">
    <el-input class="search" :placeholder="$t('searchFieldPlaceholder')" v-model="query">
      <i slot="prefix" class="el-input__icon el-icon-custom-magnify"></i>
    </el-input>
  </el-form>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import search from '.';

export default {
  name: 'SearchInput',
  props: {
    initialQuery: {
      type: String,
      required: false,
    }
  },
  data() {
    return {
      query: this.initialQuery,
    }
  },
  mounted() {
    if (this.query && this.query.trim().length > 0) {
      this.onSubmit();
    }
  },
  watch: {
    initialQuery(newQuery, oldQuery) {
      if (newQuery != this.query) {
        this.query = newQuery;
        this.onSubmit();
      }
    },
  },
  computed: {
    ...mapState(search.store.namespace, [
      'request',
    ]),
  },
  methods: {
    ...mapActions(search.store.namespace, [
      'sendQuery',
      'cancelQuery'
    ]),
    onSubmit() {
      this.sendQuery(this.query.trim());
    },
  },
}
</script>
